// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"blog-dropdown-menu-module--dropdown--3o2_n","dropdownTitle":"blog-dropdown-menu-module--dropdownTitle--2SWqS"};